import { InfoIcon, TriangleAlertIcon } from "lucide-react";

import { Row } from "@/components/Row";

export const InfoBox = ({
  variant = "info",
  children,
}: {
  variant?: "info" | "warning";
  children: React.ReactNode;
}) => {
  if (variant === "warning") {
    return (
      <Row className="items-start gap-2 rounded-md bg-amber-50 p-3 text-sm text-amber-800">
        <TriangleAlertIcon className="mt-0.5 h-4 w-4 shrink-0" />
        <div>{children}</div>
      </Row>
    );
  }

  return (
    <Row className="items-start gap-2 rounded-md bg-primary-50 p-3 text-sm text-primary-800">
      <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" />
      <div>{children}</div>
    </Row>
  );
};
